import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CurrencyFormat from "react-currency-format";

interface BalanceDetailProps {
  title: string;
  amount: number;
  symbol: string;
}

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
  },
  amount: {
    fontSize: 32,
  },
}));

export const BalanceDetail = (props: BalanceDetailProps) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1} item xs={12} sm={4} lg={3}>
      <Grid item xs={12}>
        <Typography className={classes.title} variant="h4" component="h4">
          {props.title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CurrencyFormat
          value={props.amount}
          prefix={props.symbol}
          displayType="text"
          thousandSeparator={true}
          fixedDecimalScale={true}
          decimalScale={2}
          renderText={(formattedValue: string) => (
            <Typography className={classes.amount} variant="h2" component="h2">
              {formattedValue}
            </Typography>
          )}
        />
      </Grid>
    </Grid>
  );
};
